import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { EntityRefData } from './entityRefData.component';
import { selectEntities, selectSlugs } from '../../../modules/contentRegistry';

const mapStateToProps = createStructuredSelector({
  allEntities: selectEntities,
  slugs: selectSlugs,
});

export const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(EntityRefData);
